import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import HandlingErrorsHelper from '@components/collection/components/globals/helpers/handling-errors.helper';
import store from 'redux/store';
import axios from 'axios';
var GENERAL_CONFIG_URL = 'api/v2/customerfacing/config/general';
var CUSTOMER_CONFIG_URL = 'api/v2/customerfacing/config/customer';

var RestService = /*#__PURE__*/function () {
  function RestService() {
    _classCallCheck(this, RestService);

    this.requestUrls = {};
    this.errorCallback = null;
    this.urlsToExcludeFromError = [];
  }

  _createClass(RestService, [{
    key: "setErrorCallback",
    value: function setErrorCallback(errorCallback) {
      this.errorCallback = errorCallback;
    }
  }, {
    key: "setUrlsToExcludeFromError",
    value: function setUrlsToExcludeFromError(urlsToExcludeFromError) {
      this.urlsToExcludeFromError = urlsToExcludeFromError;
    }
  }, {
    key: "setConf",
    value: function setConf(config) {
      this.config = config;
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;

      function guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }

      localStorage.setItem('code', guid());
      return new Promise(function (resolve, reject) {
        _this.request(GENERAL_CONFIG_URL, {
          method: "GET"
        }, true).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "initCustomerConfig",
    value: function initCustomerConfig() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.request(CUSTOMER_CONFIG_URL, {
          method: "GET"
        }, true).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "request",
    value: function request(url, params) {
      var _this3 = this;

      var noCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var ignoreDebouncing = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var returnObject = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      ignoreDebouncing = url.indexOf('favouriteAndLastPlayed') === -1 && url.indexOf('customerfacing/cms/menu/search') === -1;

      var apiCall = function apiCall(resolve, reject) {
        var cacheStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (headers && (Object.keys(headers).length === 0 || headers['content-type'] == 'application/json')) {
          headers["content-type"] = "application/json";
        }

        params.data = params.body;

        if (new Date().getTime() - (_this3.requestUrls[url] || 0) < 500 && ignoreDebouncing === false) {
          return;
        }

        var urlObj = new URL(_this3.config.apiDomain + url);
        var encodedUrl = urlObj.origin + urlObj.pathname;

        if (urlObj.search.length > 0) {
          encodedUrl += urlObj.search.replace('@', '@').replace(':', encodeURIComponent(':')).replace('$', encodeURIComponent('$')).replace(',', encodeURIComponent(',')).replace('+', encodeURIComponent('+')).replace('[', encodeURIComponent('[')).replace(']', encodeURIComponent(']'));
        }

        axios(Object.assign({
          url: encodedUrl,
          headers: Object.assign({
            "code": btoa(localStorage.getItem('code') + window.location.href),
            "labelEntryPointCode": _this3.config.labelCode
          }, headers),
          withCredentials: true
        }, params)).then(function (response) {
          if (returnObject) {
            resolve(response);
            return;
          }

          var json = response.data;
          resolve(json);

          if (!noCache) {
            cacheStorage.put(url, response.request.response);
          }

          return response;
        }).catch(function (error) {
          var response = error.response;
          var errorMessage = response.data;
          var getTranslations = store.getState().translations.data;

          if (url.indexOf('customers/findByEmail') === -1 && url.indexOf('currentCustomer') === -1 && url.indexOf('customers/activate') === -1 && url.indexOf('/login') === -1) {
            var handlingErrorsHelperInstance = new HandlingErrorsHelper(errorMessage, getTranslations, response.status, _this3.errorCallback, url, _this3.urlsToExcludeFromError);
            handlingErrorsHelperInstance.getErrorMessage();
          }

          reject(errorMessage);
        });
        _this3.requestUrls[url] = new Date().getTime();
      };

      return new Promise(function (resolve, reject) {
        apiCall(resolve, reject);
      });
    }
  }]);

  return RestService;
}();

export default new RestService();